import post from './post.js';
import get from './get.js';

export default {
	get_list: ({ session }) => get('take_actions/list', { session }),
	create: ({ session, data }) => post('take_actions/create', { session, data }),
	delete: ({ session, uid }) => post('take_actions/delete', { session, uid }),
	get_by_id: ({ session, uid }) => get('take_actions/get', { session, uid }),
	update: ({ session, uid, data }) => post('take_actions/update', { session, uid, data }),
};
